import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import axios from "axios";
import Select from "react-select";
import moment from "moment";
import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import * as XLSX from "xlsx";
//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import html2canvas from "html2canvas";
// import { toastError, toastSuccess } from "../../../common/Toast";
// import { DATA_EXPORT, ERROR_MESSAGE } from "../../../common/Constant";
// import { Calendar } from "../../../common/imagePath";
// import ReactDatetime from "react-datetime";
import Moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { TbFileExport } from "react-icons/tb";
// import { AgGridReact } from "ag-grid-react";
// import "ag-grid-enterprise";
// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
// import "../../../assets/css/customersummary.css";
// import "jspdf-autotable";
// import autoTable from "jspdf-autotable";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const CustomerBalanceSummary = (props) => {
  const gridRef = useRef();
  const tableContainerRef = useRef();

  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const token = localStorage.getItem("Token");
  // const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  // const [selectedId, setSelectedId] = useState([]);
  // const [currentPage, setCurrentPage] = useState(1);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [toggle, setToggle] = useState(false);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  //   if (activeAccordion === index) {
  //     return <FontAwesomeIcon icon={faChevronUp} />;
  //   } else {
  //     return <FontAwesomeIcon icon={faChevronDown} />;
  //   }
  // };

  // const generateBarcodes = () => {
  //   barcodeRefs.current.forEach((barcodeRef, index) => {
  //     // console.log("barcodeRefs", barcodeRefs);
  //     var g = document.getElementsByTagName(barcodeRef);
  //     const barcodeValue = paramObject.id;
  //     // console.log("barcodeValue", barcodeValue);
  //     const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
  //     JsBarcode(barcodeRef, paddedBarcodeValue, {
  //       width: data.width,
  //       height: data.height,
  //       fontSize: data.fontSize,
  //       displayValue: true,
  //       fontoptions: "bold",
  //       textAlign: "center",
  //       font: "monospace",
  //       textPosition: "bottom",
  //       textMargin: 2,
  //       margin: 10,
  //       marginTop: undefined,
  //       marginBottom: undefined,
  //       marginLeft: undefined,
  //       marginRight: undefined,
  //       format: "CODE128",
  //       valid: () => true,
  //       background: "#ffffff",
  //       lineColor: "#000000",
  //       padding: data.zeroFill,
  //     });
  //   });
  // };

  const handletoggle = () => {
    setToggle(!toggle);
  };

  // let columnDefs = [
  //   { headerName: "Name", field: "Name", minWidth: toggle ? 900 : 1010 },
  //   {
  //     headerName: "OpeningBalance",
  //     field: "Openingbalance",
  //     enableValue: true,
  //     minWidth: 130,
  //     suppressMenu: true,
  //     filter: "agNumberColumnFilter",

  //     aggFunc: "sum",
  //     valueGetter: ({ data }) =>
  //       // Parse the string OpenBalance and return as an integer

  //       `$ ${Number(data.Openingbalance).toFixed(2)}`,
  //   },
  // ];

  const columns = useMemo(() => [
    // {
    //   header : "Row Number" ,
    //   accessorKey : "RowNumber"
    // },
    {
      header: "Customer Name",
      accessorKey: "CustomerName",
      filterFn : "contains",
    },
    {
      header: "Balance",
      accessorKey: "Balance",
      filterFn : "contains",
      size:"90",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {Number(row.original.Balance ? row.original.Balance : 0).toFixed(2)}
          </div>
        );
      },
    },
    // {
    //   header : "Customer Id",
    //   accessorKey : "Customerid"
    // },
    // {
    //   header : "Total Record",
    //   accessorKey : "TotalRecord",
    //   size:"90",
    // },
  ]);

  if (toggle) {
    columns = [
      ...columns,
      {
        headerName: "Discount(%)",
        enableValue: true,
        suppressMenu: true,
        field: "discount",
        defaultColDef: { cellClass: "cell-wrap-text" },
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        valueGetter: ({ data }) => {
          // if (toggle) {

          if (totalSum == 0) {
            return `$0.00`;
          } else {
            return `$ ${(
              (Number(data.Openingbalance).toFixed(2) /
                Number(totalSum).toFixed(2)) *
              100
            ).toFixed(2)}`;
          }
          //  const val=((Number(data.Openingbalance).toFixed(2) / Number(totalSum).toFixed(2)) * 100).toFixed(2)
          //  console.log(val,"value")

          // } else {
          //   return "";
          // }
        },
      },
    ];

    responseData?.forEach((row) => {
      const discountPercentage = (
        (Number(row.Openingbalance).toFixed(2) / Number(totalSum).toFixed(2)) *
        100
      ).toFixed(2);
      row.discount = discountPercentage;
    });
  }

  const defaultColDef = useMemo(() => {
    return {
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 100,
      flex: 1,
    };
  }, []);

  // const onGridReady = useCallback((params) => {
  //   setLoading(true);

  //   axios
  //     .get(
  //       `${
  //         config.reportsBaseUrl
  //       }/reports/customerbalancesummary?startdate=${""}&enddate=${""}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         setResponseData(res.data.ResponseData);
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setLoading(false);
  //     });
  // }, []);

  //Function for downloading pdf of barcodesheet

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const FilterColumnText = {};
  FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
    return { columnname: el.id, value: el.value, id: index + 1 };
  });

  let FilterColumnSearchText = JSON.stringify(FilterColumnText);

  const paramObject = useParams();

  const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

  const apicall = () => {
    setLoading(true);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/customerbalancesummary?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )

      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          const FilterData = res.data.ResponseData?.map((el) => ({
            ...el,
            Balance: Number(el?.Balance),
            CustomerName: String(el?.CustomerName),
          })); 
          setResponseData(FilterData);
          setRowCount(res.data.ResponseData[0].TotalRecord);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setLoading(false);
      });
  };

  console.log(responseData, "responseData112");

  useEffect(() => {
    apicall();
  }, [
    FilterColumnSearchText,
    columnIndex,
    pagination,
    globalFilter,
    startdate,
    enddate,
    sorting,
  ]);

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  }, []);

  //Function for export excel

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = parseFloat(report.Balance);
      console.log(reportTotal, "154sdxfg");
  
      if (!isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        console.log(`Invalid number: ${report.Balance}`);
        return total;
      }
    }, 0);
  
    setTotalSum(sum);
  };

  // console.log(typeof totalSum,"totalSum")

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };
  const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

  const currentDate = new Date();

  // const setPrinterFriendly = (api) => {
  //   const eGridDiv = document.querySelector('#myGrid');
  //   eGridDiv.style.width = '';
  //   eGridDiv.style.height = '';
  //   api.setDomLayout('print');
  // };

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `CustomerBalanceSummary_.xlsx`);
  };

  // const downloadSlectedRowPDF = (rows) => {
  //   const newData = rows.map((row) => row.original);
  //   console.log(newData, "newData");
  //   setLoading(true);
  //   var doc = new jsPDF("p", "pt", "a4");

  //   // Add the header
  //   let headerElement = document.querySelector("#header");
  //   let clonedHeader = headerElement.cloneNode(true);
  //   clonedHeader.style.fontSize = `10px`;
  //   clonedHeader.style.width = "560px";
  //   clonedHeader.style.margin = "1rem";

  //   let content = "";
  //   let startIndex = 1;
  //   let endIndex = 25;

  //   for (var i = 1; i <= Math.ceil(newData.length / 25); i++) {
  //     if (i == 1) {
  //       clonedHeader.style.marginTop = "2rem";
  //     }
  //     if (i > 1) {
  //       clonedHeader.style.marginTop = "2.5rem";
  //     }
  //     // Printing header
  //     content += " " + clonedHeader.outerHTML;

  //     // Printing table body
  //     content +=
  //       '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
  //     content +=
  //       "<thead><tr style='margin-bottom: 5px'>" +
  //       '<th style="padding: 7px;" className="p-regular">No</th>' +
  //       '<th style="padding: 7px;" className="p-regular">CustomerName</th>' +
  //       '<th style="padding: 7px;" className="p-regular">Date</th>' +
  //       '<th style="padding: 7px;" className="p-regular">TransactionType</th>' +
  //       '<th style="padding: 7px;" className="p-regular">Transaction No.</th>' +
  //       '<th style="padding: 7px;" className="p-regular">Name</th>' +
  //       '<th style="padding: 7px;" className="p-regular">Quantity</th>' +
  //       '<th style="padding: 7px;" className="p-regular">Rate</th>' +
  //       '<th style="padding: 7px;" className="p-regular">AmountLine</th>' +
  //       '<th style="padding: 7px;" className="p-regular">Balance</th>' +
  //       "</tr></thead>";
  //     content += "<tbody>";

  //     // Loop for printing items based on endIndex
  //     for (let index = startIndex; index <= endIndex; index++) {
  //       if (index <= newData.length) {
  //         content +=
  //           "<tr>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           index +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           newData[index - 1].Customername +
  //           "</td>" +
  //           '<td style="font-size: 6px; padding: 7px;">' +
  //           moment(newData[index - 1].DATE).format("YYYY-MM-DD") +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           newData[index - 1].TransactionType +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           newData[index - 1].Transactionnumber +
  //           "</td>" +
  //           '<td style="font-size: 6px; ">' +
  //           newData[index - 1].Name +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           newData[index - 1].Quantity +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
  //           newData[index - 1].Rate +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           Number(newData[index - 1].Amountline).toFixed(2) +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           Number(newData[index - 1].Balance).toFixed(2) +
  //           "</td>" +
  //           "</tr>";
  //       }

  //       if (index % 25 == 0) {
  //         startIndex = startIndex + 25;
  //         endIndex = endIndex + 25;
  //         break;
  //       }
  //     }

  //     content += "</tbody>";
  //     content += "</table>";

  //     content +=
  //       '<div style="text-align: center; width: 560px">' +
  //       '<p style= "text-align: center; margin-top: 1rem; font-size: 9px; font-weight: bold;">' +
  //       i +
  //       "</p>" +
  //       "</div>";
  //   }

  //   // Printing page
  //   doc.html(content, {
  //     callback: function (pdf) {
  //       pdf.save("Sales-Customer-Details.pdf");
  //       setLoading(false);
  //     },
  //   });
  // };
  function isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  }

  const downloadPDF = (rows, field, visibleColumns) => {
    console.log("visibleColumns=>", visibleColumns);
    let reportMainHeading = "Sonar POS";
    let reportHeading = "Customer Balance Summary";
    let reportDateHeading =
      startdate && enddate ? `From: ${startdate} To: ${enddate}` : "All Date";

    visibleColumns = visibleColumns.filter(
      (col) => col.columnDef.header !== "Select"
    );

    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = responseData.map((el) => {
        return {
          ...el,
          OpenBalance:
            el.OpenBalance == null || el.OpenBalance === "NaN"
              ? ""
              : parseFloat(el.OpenBalance),
          ModifiedBy: el.ModifiedBy == null ? "" : el.ModifiedBy,
          DeliveryAddress: el.DeliveryAddress == null ? "" : el.DeliveryAddress,
        };
      });
    }

    const doc = new jsPDF("p", "mm", "a4");

    let pageWidth = doc.internal.pageSize.width;
    let pageHeight = doc.internal.pageSize.height;

    let itemsPerPage = Math.floor(pageHeight); // Adjust the factor based on your content
    console.log("itemsPerPage=>", itemsPerPage);

    doc.setFontSize(10);

    for (
      let currentPage = 1, rowNumber = 1;
      rowNumber <= newData.length;
      currentPage++
    ) {
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = Math.min(currentPage * itemsPerPage, newData.length);

      // Dynamic header
      const header = [
        "No",
        ...visibleColumns.map((col) => col.columnDef.header),
      ];

      // Extract data for the current page
      const pageData = newData.slice(startIndex, endIndex);

      // Calculate header height
      const headerHeight = doc.getTextDimensions(header.join(" ")).h + 2;

      // Calculate startY for the first page, and for subsequent pages, consider header height
      const startY = currentPage === 1 ? 25 : headerHeight; // Adjust as needed

      // Build the table content
      const content = {
        startY: startY,
        head: [header],
        body: pageData.map((row) => {
          // Parse row data dynamically
          const parsedRow = visibleColumns.map((col) => {
            const dataValue = row[col.columnDef.id];
            let value = "";

            if (typeof dataValue === "number") {
              value = parseFloat(dataValue);
            } else if (typeof dataValue === "string") {
              value = dataValue;
            } else if (moment(dataValue).isValid()) {
              value = moment(dataValue).format("YYYY-MM-DD (HH:mm)");
            }

            return value;
          });

          return [rowNumber++, ...parsedRow];
        }),
        headStyles: { fillColor: [100, 100, 100] },
      };

      // Add the header on every page
      let textWidth =
        (doc.getStringUnitWidth(reportMainHeading) *
          doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerX = (pageWidth - textWidth) / 2;
      doc.text(reportMainHeading, centerX, 10);

      let textWidthHeading =
        (doc.getStringUnitWidth(reportHeading) * doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerXHeading = (pageWidth - textWidthHeading) / 2;
      doc.text(reportHeading, centerXHeading, 15);

      let textWidthDate =
        (doc.getStringUnitWidth(reportDateHeading) *
          doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerXDate = (pageWidth - textWidthDate) / 2;
      doc.text(reportDateHeading, centerXDate, 20);

      doc.setPage(currentPage);
      doc.autoTable(content);

      // Add page break if not the last page
      if (currentPage < Math.ceil(newData.length / itemsPerPage)) {
        doc.addPage();
      }
    }

    doc.save("Customer_Balance_Summary.pdf");
  };

  

  // const downloadPDF = (rows, field, visibleColumns) => {
  //   console.log("columnsFiled=>", visibleColumns);

  //   let newData = [];
  //   if (field === "selectedrow") {
  //     newData = rows.map((row) => row.original);
  //   } else if (field === "alldata") {
  //     newData = responseData.map(el => {
  //       return {
  //         ...el , 
  //         OpenBalance : el.OpenBalance == null ? "" : el.OpenBalance === "0.00" ? '': el.OpenBalance ,
  //         ModifiedBy : el.ModifiedBy == null ? "" : el.ModifiedBy ,
  //         DeliveryAddress : el.DeliveryAddress == null ? "" : el.DeliveryAddress
  //        };
  //     });
  //   }


  //   console.log(newData, "newData");
    
   
  //   var doc = new jsPDF("l", "pt", "a3");

  //   // Add the header
  //   let headerElement = document.querySelector("#header");
  //   let clonedHeader = headerElement.cloneNode(true);
  //   clonedHeader.style.fontSize = `10px`;
  //   clonedHeader.style.width = "560px";
  //   clonedHeader.style.marginLeft = "15rem";

  //   let content = "";
  //   let startIndex = 1;
  //   let endIndex = 15;

  //   for (var i = 1; i <= Math.ceil(newData.length / 15); i++) {
  //     if (i == 1) {
  //       clonedHeader.style.marginTop = "2rem";
  //     }
  //     if (i > 1 && i < Math.ceil(newData.length / 15)) {
  //       clonedHeader.style.marginTop = "19rem";
  //     }

  //     if (i == Math.ceil(newData.length / 15)) {
  //       clonedHeader.style.marginTop = "7rem";
  //     }
  //     // Printing header
  //     content += " " + clonedHeader.outerHTML;

  //     // Printing table body
  //     content +=
  //       '<table style="font-size: 8px; margin-left: 2rem; margin-top: 2rem;  width: 1140px; border: 1px solid #f5f5f5">';
  //     content += "<thead><tr style='margin-bottom: 5px'>";

  //     content += '<th style="padding: 7px;" className="p-regular">No</th>';
  //     for (var j = 0; j <= visibleColumns.length; j++) {
  //       if (j > 0) {
  //         var columnHeaderData = visibleColumns[j];
  //         if (columnHeaderData != undefined) {
  //           console.log("columnHeaderData", columnHeaderData);
  //           content +=
  //             '<th style="padding: 7px;" className="p-regular">' +
  //             columnHeaderData.id +
  //             "</th>";
  //         }
  //       }
  //     }

  //     content += "</tr></thead>";
  //     content += "<tbody>";

  //     // Loop for printing items based on endIndex
  //     for (let index = startIndex; index <= endIndex; index++) {
  //       if (index <= newData.length) {
  //         content +=
  //           "<tr>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           index +
  //           "</td>";

  //         for (var j = 0; j <= visibleColumns.length; j++) {
  //           if (j > 0) {
  //             var columnHeaderData = visibleColumns[j];
  //             // console.log(
  //             //   "Date Parse= >",
  //             //   newData[index - 1][columnHeaderData.id]
  //             // );
  //             if (columnHeaderData != undefined) {
  //               content +=
  //                 '<td style="font-size: 7px; padding: 7px;">' +
  //                 (moment(newData[index - 1][columnHeaderData?.id]).isValid()
  //                   ? moment(newData[index - 1][columnHeaderData?.id]).format(
  //                       "YYYY-MM-DD"
  //                     )
  //                   : newData[index - 1][columnHeaderData?.id]) +
  //                 "</td>";
  //             }
  //           }
  //         }

          
  //         content += "</tr>";
  //       }

  //       if (index % 15 == 0) {
  //         startIndex = startIndex + 15;
  //         endIndex = endIndex + 15;
  //         break;
  //       }
  //     }

  //     content += "</tbody>";
  //     content += "</table>";

  //     content +=
  //       '<div style="text-align: center; width: 560px;margin-left: 220px">' +
  //       '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
  //       i +
  //       "</p>" +
  //       "</div>";
  //   }

  //   // Printing page
  //   doc.html(content, {
  //     callback: function (pdf) {
  //       pdf.save("Customer_Balance_Summary.pdf");
  //       setLoading(false);
  //     },
  //   });
  // };

  // const onBtExport = useCallback(() => {
  //   gridRef.current.api.exportDataAsExcel({
  //     fileName: `Customer_Balance_Summary_${Moment(currentDate).format(
  //       "MM/DD/YYYY"
  //     )}`,
  //   });
  // }, []);

  const onBtExport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(responseData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `CustomerBalanceSummary__.xlsx`);
  };

  const onBtPrint = () => {
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 23;

    for (var i = 1; i <= Math.ceil(responseData.length / 23); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header-
      content += " " + clonedHeader.outerHTML;

      // Printing table body-
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 8px;" className="p-regular">Row No</th>' +
        '<th style="padding: 8px;" className="p-regular">CompanyName</th>' +
        '<th style="padding: 8px; width: 230px">Openingbalance</th>';
      if (toggle) {
        content +=
          '<th style="padding: 8px;" className="p-regular">% of column</th>';
      }
      content += "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startIndex; index <= endIndex; index++) {
        if (index >= startIndex && index <= responseData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            '<td style="font-size: 8px; padding: 8px;">' +
            responseData[index - 1].CompanyName +
            "</td>" +
            '<td style="font-size: 8px; padding: 8px;">' +
            Number(responseData[index - 1].Openingbalance).toFixed(2) +
            "</td>";

          // Conditionally show/hide % of column
          if (toggle) {
            content +=
              '<td style="font-size: 8px; padding: 8px;">' +
              responseData[index - 1].discount +
              "</td>";
          }

          content += "</tr>";
        }

        if (index % 23 == 0) {
          startIndex = startIndex + 23;
          endIndex = endIndex + 23;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";
    }

    // Printing page-
    doc.html(content, {
      callback: function (pdf) {
        pdf.output("dataurlnewwindow");
      },
    });
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Customer Balance Summary Report</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Customer Balance Summary Report
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-11 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find(e => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-6 ">
              <div className="row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            </div>
            {/* <div className="col-sm-2 align-self-sm-end">
              <button
              type="submit"
              className="btn btn-primary pull-right"
              style={{ marginLeft: "auto" }}
              onClick={apicall}
              >
              Generate Report
              </button>
            </div> */}
          </div>

          {/* <div style={{ display: "flex" }} className="space">
            <div className="col-md-1">
              <label className="col-form-label">% of column</label>
            </div>
            <div class="form-check form-switch  col-md-4">
              <input
                class="form-check-input mt-2"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
                onClick={handletoggle}
              />
              <label class="form-check-label" for="flexSwitchCheckDefault">Default switch checkbox input</label>
            </div>
          </div> */}

          {/* Receipt */}

          <div className="card mt-3">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h6 className="p">SonarPos</h6>
                  <p className="fw-bold p-regular">Customer Balance Summary</p>
                  <div className="row">
                    {/* <p> Date: {new Date().toLocaleDateString()}</p>
                    <p>
                      Date: {startdate} - {enddate}
                    </p> */}
                    <p>
                      Date:{" "}
                      {startdate === "" && enddate === ""
                        ? "All Data"
                        : startdate + " - " + enddate}
                    </p>
                  </div>
                </div>
              </div>
              <hr />

              {/* <div style={containerStyle}> */}
              <div className="">
                <div className="">
                  {/* <div className="container"> */}
                  {/* <div className="button"> */}
                  {/* <button
                      onClick={onBtExport}
                      className="btn btn-sm btn-outline-dark  m-1"
                      // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                    >
                      <i class="fas fa-file-excel "></i>
                      Export to Excel
                    </button> */}
                  {/* <button
                      onClick={downloadPDF}
                      className="btn btn-sm btn-outline-dark  m-1"
                      // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                    >
                      <i class="fas fa-file-export "></i>
                      Export to Pdf
                    </button> */}
                  {/* <button
                      className="btn btn-sm btn-outline-dark  m-1"
                      onClick={onBtPrint}
                    >
                      <i class="fas fa-print"></i>
                      Print
                    </button> */}
                  {/* </div> */}

                  {/* <div className="grid-wrapper" ref={tableContainerRef}> */}
                  {/* <div id="myGrid" className="ag-theme-alpine"> */}
                  {/* <AgGridReact
                        ref={gridRef}
                        rowData={responseData}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        onGridReady={onGridReady}
                        rowGroupPanelShow={'always'}
                      onFirstDataRendered={onFirstDataRendered}
                      pagination={true}
                      ></AgGridReact> */}
                  {/* </div> */}
              
                  <div>
                    {/* <MaterialReactTable
                      muiTableContainerProps={{
                        sx: { maxHeight: "fit-content" },
                      }}
                      columns={columns}
                      data={responseData}
                      enableColumnFilters
                      sortDescFirst
                      enableColumnResizing
                      enableGrouping
                      enableStickyHeader
                      enableStickyFooter
                      enableRowSelection
                      enableColumnOrdering
                      initialState={{
                        density: "compact",
                        expanded: true, //expand all groups by default
                        // grouping: ["SupplierName"], //an array of columns to group by by default (can be multiple)
                        pagination: { pageIndex: 0, pageSize: 25 },
                        // sorting: [{ id: "state", desc: false }], //sort by state by default
                      }}
                      // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                      // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
                      muiPaginationProps={{
                        rowsPerPageOptions: [25, 50, 100, 300, 500],
                      }}
                      manualFiltering
                      manualPagination
                      manualSorting
                      // muiToolbarAlertBannerProps={
                      //   isError
                      //     ? {
                      //         color: "error",
                      //         children: "Error loading data",
                      //       }
                      //     : undefined
                      // }
                      muiTableBodyProps={{
                        sx: () => ({
                          "& tr:nth-of-type(even)": {
                            backgroundColor:
                              "var(--datatable-row-background-color)",
                            //'rgb(237 237 233 / 63%)'
                          },
                          "& td": {
                            borderRight:
                              "1px solid var(--datatable-row-background-hover-color)",
                            lineHeight: "16px",
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "var(--primary-color-800)",
                            fontFamily: "Inter",
                          },

                          "& tr": {
                            lineHeight: "16px",
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "var(--primary-color-800)",
                            fontFamily: "Inter",
                          },
                        }),
                      }}
                      muiTableHeadCellProps={{
                        sx: (theme) => ({
                          background: "var(--datatable-row-background-color)", //'#e9e9e9',
                          borderRight:
                            "1px solid var(--datatable-row-background-hover-color)",
                          lineHeight: "16px",
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "var(--primary-color-800)",
                          fontFamily: "Inter",
                        }),
                      }}
                      muiToolbarAlertBannerProps={
                        // isError
                        // ? {
                        //   color: "error",
                        //   children: "Error loading data",
                        // }
                        // : undefined
                        {
                          isError: () => ({
                            color: "error",
                            children: "Error loading data",
                          }),
                          sx: (theme) => ({
                            background: "var(--datatable-row-background-color)", //'#e9e9e9',
                            lineHeight: "16px",
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "var(--primary-color-800)",
                            fontFamily: "Inter",
                          }),
                        }
                      }
                      muiSelectCheckboxProps={{
                        sx: (theme) => ({
                          lineHeight: "16px",
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "var(--prinary-color-800)",
                          fontFamily: "Inter",
                        }),
                      }}
                      muiSelectAllCheckboxProps={{
                        sx: (theme) => ({
                          lineHeight: "16px",
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "var(--prinary-color-800)",
                          fontFamily: "Inter",
                        }),
                      }}
                      onColumnFiltersChange={setColumnFilters}
                      onGlobalFilterChange={setGlobalFilter}
                      onPaginationChange={setPagination}
                      onSortingChange={setSorting}
                      rowCount={rowCount}
                      state={{
                        columnFilters,
                        globalFilter,
                        isLoading,
                        pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting,
                      }}
                      renderTopToolbarCustomActions={({ table }) => (
                        <Box
                    sx={{
                      display: "flex",
                      gap: "0.3rem",
                      p: "0.5rem",
                      flexWrap: "wrap",
                    }}
                  >
                    <Button
                      // size="small"
                      className="btn btn-sm btn-secondary"
                      style={{ display: "flex" }}
                      color="primary"
                      //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                      onClick={onBtExport}
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export All In Excel
                    </Button>
                    <Button
                      // size="small"
                      className="btn btn-sm btn-secondary"
                      style={{ display: "flex" }}
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      onClick={() =>
                        handleExportRows(table.getSelectedRowModel().rows)
                      }
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export Selected Rows in Excel
                    </Button>
                    <Button
                      // size="small"
                      className="btn btn-sm btn-secondary"
                      style={{ display: "flex" }}
                      color="primary"
                      //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                      onClick={() =>
                        downloadPDF(
                          "",
                          "alldata",
                          table.getVisibleFlatColumns()
                        )
                      }
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export All In Pdf
                    </Button>
                    <Button
                      // size="small"
                      className="btn btn-sm btn-secondary"
                      style={{ display: "flex" }}
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      onClick={() =>
                        downloadPDF(
                          table.getSelectedRowModel().rows,
                          "selectedrow"
                        )
                      }
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export Selected Rows in Pdf
                    </Button>
                    {/* <Button
                    size="small"
                    onClick={() =>
                      // setPagination({ ...pagination, pageSize: totalRows })
                      setPagination({
                        ...pagination,
                        pageIndex: 0,
                        pageSize: rowCount,
                      })
                    }
                    variant="contained"
                  >
                    Get All Data
                  </Button> */}
                  {/* </Box>
                      )}
                    /> */} 

                    <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Customer Balance Summary"
                    columns={columns}
                    data={responseData}
                    startdate={startdate}
                    enddate={enddate}
                    columnGrouping={[]}
                    columnsVisibility={{}}
                  />
            
                  </div>

                  {/* </div> */}

                  <div style={{ textAlign: "right" }} className=" mt-5 ">
                    <p class="text-right p-medium">
                      Total Amount: ${Number(totalSum).toFixed(2)}
                    </p>
                    <hr
                      style={{
                        display: "inline-block",
                        borderBottom: "3px solid black",
                        width: "30%",
                      }}
                    />
                  </div>
                  <hr />
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 text-center">
                  {/* <h6>
                    {" "}
                    {currentDate.toLocaleString()} &nbsp;GMT Time: {hours}:
                    {minutes}
                  </h6> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ display: "none" }}>
        {responseData.map((item) => (
          <>
            {/* <button onClick={console.log("item", item)}>click me</button> */}
            <div key={item.SaleId}>
              <canvas
                data-name={item.SaleId}
                ref={(el) => (barcodeRefs.current[item.SaleId] = el)}
                id={`barcode-${item.SaleId}`}
              />
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export default CustomerBalanceSummary;
